import React, { useContext, useState } from "react";
import { IconMenu, Popover } from "@panda0/panda0-ui";
import { cn } from "@panda0/panda0-utils";
import { ArrowDownWideNarrow, ChevronDown } from "lucide-react";

import { InsightsDisplayContext, sortOptions } from "./types";

// Insight display component (similar to job-sort)
function InsightSort() {
  const [openPopover, setOpenPopover] = useState(false);
  const { sortBy, setSort } = useContext(InsightsDisplayContext);

  const selectedSort =
    sortOptions.find((s) => s.slug === sortBy) ?? sortOptions[0];

  return (
    <Popover
      content={
        <div className="w-full p-2 md:w-48">
          {sortOptions.map(({ display, slug }) => (
            <button
              key={slug}
              onClick={() => {
                setSort(slug);
                setOpenPopover(false);
              }}
              className="flex w-full items-center justify-between space-x-2 rounded-md px-1 py-2 hover:bg-neutral-100 active:bg-neutral-200"
            >
              <IconMenu
                text={display}
                icon={<ArrowDownWideNarrow className="h-4 w-4" />}
              />
              {sortBy === slug && (
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                >
                  <path
                    d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  ></path>
                </svg>
              )}
            </button>
          ))}
        </div>
      }
      openPopover={openPopover}
      setOpenPopover={setOpenPopover}
    >
      <button
        onClick={() => setOpenPopover(!openPopover)}
        className={cn(
          "group flex h-10 cursor-pointer appearance-none items-center gap-x-2 truncate rounded-md border px-3 text-sm outline-none transition-all",
          "border-neutral-200 bg-white text-neutral-900 placeholder-neutral-400",
          "focus-visible:border-neutral-500 data-[state=open]:border-neutral-500 data-[state=open]:ring-4 data-[state=open]:ring-neutral-200"
        )}
      >
        <ArrowDownWideNarrow className="h-4 w-4" />
        <span className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-left text-neutral-900">
          {selectedSort.display || "Sort by"}
        </span>
        <ChevronDown className="h-4 w-4 flex-shrink-0 text-neutral-400 transition-transform duration-75 group-data-[state=open]:rotate-180" />
      </button>
    </Popover>
  );
}

export default React.memo(InsightSort);
